import React from "react";

const Infographtab = ({ tabs, selectedTab, onSelectTab }) => {
  return (
    <div className="w-full h-[25px]  flex items-center space-x-6 justify-center pr-2 ">
      {tabs.map((tab, index) => (
        <div
          key={index}
          onClick={() => onSelectTab(index)}
          className={`flex items-center gap-2 py-1 [font-family:'Inter-Regular',Helvetica] tracking-[0] text-lg font-roboto whitespace-nowrap leading-5 cursor-pointer ${
            selectedTab === index
              ? "text-[#e17954] border-b-4 border-[#e17954]"
              : "text-[#1d2951]"
          }`}
          style={{ fontSize: '10px' }}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};

export default Infographtab;
